<div class="relative flex min-h-screen items-center justify-center px-4">
  <button
    (click)="toggleLanguage()"
    [class]="
      'border-primary text-primary hover-border-primary hover-bg-primary absolute top-6 flex h-9 cursor-pointer items-center justify-center gap-2 rounded-lg border-2 bg-white px-4 py-2 transition-all hover:text-white active:scale-95' +
      (currentLocale() === 'en' ? ' left-6' : currentLocale() === 'ar' ? ' right-6' : '')
    ">
    <svg class="h-4 w-4 transition-colors" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M2 12H22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
    <span class="font-['Inter'] text-sm font-medium whitespace-nowrap transition-colors">
      {{ currentLocale() == "en" ? "العربية" : "English" }}
    </span>
  </button>

  <div class="max-w-md text-center">
    <h1 class="text-8xl font-extrabold text-gray-800">404</h1>

    <p class="mt-4 text-2xl font-semibold text-gray-700" i18n="@@notfoundTitle">Page not found</p>

    <p class="mt-2 text-gray-500" i18n="@@notfoundDescription">
      The page you are looking for doesn’t exist or has been moved.
    </p>

    <div class="mt-6 flex justify-center gap-4">
      <button
        i18n="@@notfoundGoHome"
        (click)="goHome()"
        class="bg-primary hover-bg-primary-hover cursor-pointer rounded-lg px-6 py-2 font-medium text-white transition">
        Go Home
      </button>

      <a
        i18n="@@notfoundDashboard"
        routerLink="/user"
        class="cursor-pointer rounded-lg border border-gray-300 px-6 py-2 font-medium text-gray-700 transition hover:bg-gray-200">
        Dashboard
      </a>
    </div>
  </div>
</div>
